<section class="-mb-1 pt-7">
  <div [class]="data.background === 'gray' ? 'mask-curve-top bg-gray-light' : ''">
    <div class="desk:centered-with-padding py-16">
      <div class="px-5 desk:px-0">
        <app-title [title]="data.title" size="h2" />
      </div>

      @if (data.text; as text) {
        <div class="px-5 pt-6 desk:px-0">{{ text }}</div>
      }

      <div
        class="no-scrollbar flex h-80 w-screen gap-x-4 overflow-x-scroll px-5 pt-6 desk:grid desk:w-auto desk:grid-cols-4 desk:px-0">
        @for (content of data.contents; track $index) {
          <a [routerLink]="content.url" class="w-2/3 shrink-0 desk:w-full">
            <app-option-card [image]="content.image" [isPriority]="!isImageInPreviousBlocks && $index < 4">
              <div card-title-left>{{ content.title }}</div>
              <div card-title-right>
                <app-svg [height]="13" [width]="17" src="assets/icons/arrow-right.svg" />
              </div>
            </app-option-card>
          </a>
        }
      </div>

      @if (data.cta; as cta) {
        <div class="mx-auto w-fit pt-6">
          <app-button [label]="cta.label" [url]="cta.url" />
        </div>
      }
    </div>
  </div>
</section>
